import * as Sentry from '@sentry/react';

/**
 * The users-doc roles: `UserRole` in `services/firebaseService.ts`, plus
 * `super_admin`, which the doc can carry although that type omits it. Anything
 * else is reported as `other`.
 */
const KNOWN_ROLES: ReadonlySet<string> = new Set([
  'admin_user',
  'super_admin',
  'camp_manager',
  'camp_contributor',
  'camp_user',
]);

export const OTHER_ROLE_TAG = 'other';

/**
 * KB-4771 — the Sentry `role` tag for the current session, from the users doc.
 *
 * `undefined` (no tag) while signed out and while the profile has not resolved:
 * an absent tag claims nothing, where a guessed one would mislabel the error.
 * A role outside the known set is `other`, so a free-form value can never
 * become a tag. Role only, never email, name or uid (uid is already Sentry's
 * user id, `AuthContext.tsx`).
 */
export function resolveSentryRoleTag(
  signedIn: boolean,
  profileRole: unknown,
): string | undefined {
  if (!signedIn || profileRole === undefined || profileRole === null) return undefined;
  return typeof profileRole === 'string' && KNOWN_ROLES.has(profileRole) ? profileRole : OTHER_ROLE_TAG;
}

/** Sets (or, for `undefined`, clears) the tag. Never throws into auth. */
export function applySentryRoleTag(role: string | undefined): void {
  try {
    Sentry.setTag('role', role);
  } catch (err) {
    console.warn('[sentry] setting the role tag failed', err);
  }
}
